/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyStock } from 'app/shared/model/pharmacy-stock.model';
import { IPharmacyReturnBill } from 'app/shared/model/pharmacy-return-bill.model';

export interface IPharmacyReturnBillItem {
  id?: string;
  chargedMrp?: number;
  returnClaimed?: number;
  returnQty?: number;
  manufacDate?: number;
  expDate?: number;
  active?: boolean;
  cursor?: number;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  pharmacyStock?: IPharmacyStock | null;
  returnBill?: IPharmacyReturnBill | null;
}

export const defaultValue: Readonly<IPharmacyReturnBillItem> = {
  active: false,
};
